export function isPedidoFacilSession(pathname: string): boolean {
  if (pathname === '/pedido-facil') return true
  try {
    return sessionStorage.getItem('pedidoFacilSession') === '1'
  } catch {
    return false
  }
}

export function setPedidoFacilSession(): void {
  try {
    sessionStorage.setItem('pedidoFacilSession', '1')
  } catch {}
}
